import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.func,
  correctAnswerText: PropTypes.string,
};

export const NoCorrectAnswersGraphic = ({ children, correctAnswerText }) => {
  return (
    <svg
      width="194"
      height="128"
      viewBox="0 0 194 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{correctAnswerText}</title>
      <path
        d="M178 56.1C178 56.5971 177.552 57 177 57C176.448 57 176 56.5971 176 56.1C176 55.6029 176.333 54.9 177 54C177.667 54.9 178 55.6029 178 56.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M182 50.1C182 50.5971 181.552 51 181 51C180.448 51 180 50.5971 180 50.1C180 49.6029 180.333 48.9 181 48C181.667 48.9 182 49.6029 182 50.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M170 50.1C170 50.5971 169.552 51 169 51C168.448 51 168 50.5971 168 50.1C168 49.6029 168.333 48.9 169 48C169.667 48.9 170 49.6029 170 50.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M176 48.1C176 48.5971 175.552 49 175 49C174.448 49 174 48.5971 174 48.1C174 47.6029 174.333 46.9 175 46C175.667 46.9 176 47.6029 176 48.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M164 47.1C164 47.5971 163.552 48 163 48C162.448 48 162 47.5971 162 47.1C162 46.6029 162.333 45.9 163 45C163.667 45.9 164 46.6029 164 47.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M185 43.1C185 43.5971 184.552 44 184 44C183.448 44 183 43.5971 183 43.1C183 42.6029 183.333 41.9 184 41C184.667 41.9 185 42.6029 185 43.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M171 44.1C171 44.5971 170.552 45 170 45C169.448 45 169 44.5971 169 44.1C169 43.6029 169.333 42.9 170 42C170.667 42.9 171 43.6029 171 44.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M178 38.1C178 38.5971 177.552 39 177 39C176.448 39 176 38.5971 176 38.1C176 37.6029 176.333 36.9 177 36C177.667 36.9 178 37.6029 178 38.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M166 38.1C166 38.5971 165.552 39 165 39C164.448 39 164 38.5971 164 38.1C164 37.6029 164.333 36.9 165 36C165.667 36.9 166 37.6029 166 38.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M43.1947 56.7477C49.8282 56.7477 55.2057 51.4679 55.2057 44.9549C55.2057 38.4419 49.8282 33.1621 43.1947 33.1621C36.5611 33.1621 31.1836 38.4419 31.1836 44.9549C31.1836 51.4679 36.5611 56.7477 43.1947 56.7477Z"
        fill="#DDDDDD"
      />
      <path
        d="M16.4428 56.7482C24.9716 56.7482 31.8856 49.9599 31.8856 41.586C31.8856 33.2122 24.9716 26.4238 16.4428 26.4238C7.91398 26.4238 1 33.2122 1 41.586C1 49.9599 7.91398 56.7482 16.4428 56.7482Z"
        fill="#DDDDDD"
      />
      <path
        d="M31.4603 41.5856C38.0938 41.5856 43.4714 36.3058 43.4714 29.7928C43.4714 23.2798 38.0938 18 31.4603 18C24.8268 18 19.4492 23.2798 19.4492 29.7928C19.4492 36.3058 24.8268 41.5856 31.4603 41.5856Z"
        fill="#DDDDDD"
      />
      <path
        d="M52.4745 37.373H16.4414V56.7469H52.4745V37.373Z"
        fill="#DDDDDD"
      />
      <path
        d="M181.76 39.5872C188.537 39.5872 194.031 34.1929 194.031 27.5387C194.031 20.8845 188.537 15.4902 181.76 15.4902C174.982 15.4902 169.488 20.8845 169.488 27.5387C169.488 34.1929 174.982 39.5872 181.76 39.5872Z"
        fill="#DDDDDD"
      />
      <path
        d="M144.945 39.5892C153.659 39.5892 160.723 32.6537 160.723 24.0983C160.723 15.5429 153.659 8.60742 144.945 8.60742C136.232 8.60742 129.168 15.5429 129.168 24.0983C129.168 32.6537 136.232 39.5892 144.945 39.5892Z"
        fill="#DDDDDD"
      />
      <path
        d="M165.986 24.0969C172.764 24.0969 178.258 18.7027 178.258 12.0485C178.258 5.39429 172.764 0 165.986 0C159.209 0 153.715 5.39429 153.715 12.0485C153.715 18.7027 159.209 24.0969 165.986 24.0969Z"
        fill="#DDDDDD"
      />
      <path
        d="M181.764 19.793H144.949V39.5868H181.764V19.793Z"
        fill="#DDDDDD"
      />
      <path
        d="M91.8217 2.36472C94.9507 -0.78824 100.049 -0.78824 103.178 2.36472L105.626 4.83158C107.868 7.08997 111.234 7.80547 114.2 6.65397L117.44 5.39614C121.581 3.78846 126.239 5.86225 127.815 10.0154L129.048 13.2647C130.177 16.2394 132.961 18.2624 136.139 18.4168L139.611 18.5854C144.047 18.801 147.459 22.59 147.21 27.0251L147.015 30.4951C146.836 33.6718 148.557 36.6524 151.397 38.086L154.5 39.652C158.465 41.6536 160.041 46.5027 158.009 50.4529L156.42 53.5435C154.964 56.3729 155.324 59.7957 157.336 62.2608L159.533 64.9533C162.342 68.3948 161.809 73.4655 158.346 76.2478L155.637 78.4247C153.157 80.4176 152.093 83.6908 152.928 86.7609L153.841 90.1145C155.007 94.4008 152.457 98.816 148.162 99.95L144.802 100.836C141.726 101.648 139.423 104.206 138.937 107.35L138.406 110.785C137.728 115.175 133.603 118.172 129.218 117.46L125.788 116.904C122.647 116.394 119.503 117.794 117.78 120.469L115.899 123.391C113.494 127.125 108.506 128.185 104.79 125.752L101.883 123.848C99.2207 122.105 95.7787 122.105 93.1167 123.848L90.2097 125.752C86.4933 128.185 81.5062 127.125 79.1011 123.391L77.2193 120.469C75.4966 117.794 72.3524 116.394 69.2118 116.904L65.7812 117.46C61.3965 118.172 57.2718 115.175 56.5936 110.785L56.063 107.35C55.5772 104.206 53.2743 101.648 50.1978 100.836L46.8373 99.95C42.5423 98.816 39.9931 94.4008 41.1591 90.1145L42.0714 86.7609C42.9066 83.6908 41.8429 80.4176 39.3627 78.4247L36.6535 76.2478C33.1908 73.4655 32.6577 68.3948 35.4663 64.9533L37.6638 62.2608C39.6755 59.7957 40.0352 56.3729 38.58 53.5435L36.9904 50.4529C34.9587 46.5027 36.5342 41.6536 40.4998 39.652L43.6024 38.086C46.4428 36.6524 48.1637 33.6718 47.9851 30.4951L47.79 27.0251C47.5406 22.59 50.9522 18.801 55.3891 18.5854L58.8605 18.4168C62.0385 18.2624 64.8229 16.2394 65.9518 13.2647L67.1848 10.0154C68.7609 5.86225 73.4187 3.78846 77.5597 5.39614L80.7995 6.65397C83.7655 7.80547 87.132 7.08997 89.3732 4.83158L91.8217 2.36472Z"
        fill="#959595"
      />
      <path
        d="M98 113C125.062 113 147 91.062 147 64C147 36.938 125.062 15 98 15C70.938 15 49 36.938 49 64C49 91.062 70.938 113 98 113Z"
        fill="#333333"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M175.217 78.253C179.369 78.253 182.735 74.9482 182.735 70.8716C182.735 66.795 179.369 63.4902 175.217 63.4902C171.065 63.4902 167.699 66.795 167.699 70.8716C167.699 74.9482 171.065 78.253 175.217 78.253Z"
        fill="#DDDDDD"
      />
      <path
        d="M152.666 78.2541C158.004 78.2541 162.332 74.0051 162.332 68.7638C162.332 63.5224 158.004 59.2734 152.666 59.2734C147.328 59.2734 143 63.5224 143 68.7638C143 74.0051 147.328 78.2541 152.666 78.2541Z"
        fill="#DDDDDD"
      />
      <path
        d="M165.553 68.7628C169.705 68.7628 173.071 65.458 173.071 61.3814C173.071 57.3048 169.705 54 165.553 54C161.401 54 158.035 57.3048 158.035 61.3814C158.035 65.458 161.401 68.7628 165.553 68.7628Z"
        fill="#DDDDDD"
      />
      <path
        d="M175.218 66.127H152.664V78.2535H175.218V66.127Z"
        fill="#DDDDDD"
      />
      <path
        d="M20 114.1C20 114.597 19.5523 115 19 115C18.4477 115 18 114.597 18 114.1C18 113.603 18.3333 112.9 19 112C19.6667 112.9 20 113.603 20 114.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M34 106.1C34 106.597 33.5523 107 33 107C32.4477 107 32 106.597 32 106.1C32 105.603 32.3333 104.9 33 104C33.6667 104.9 34 105.603 34 106.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M27 103.1C27 103.597 26.5523 104 26 104C25.4477 104 25 103.597 25 103.1C25 102.603 25.3333 101.9 26 101C26.6667 101.9 27 102.603 27 103.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M16 104.1C16 104.597 15.5523 105 15 105C14.4477 105 14 104.597 14 104.1C14 103.603 14.3333 102.9 15 102C15.6667 102.9 16 103.603 16 104.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M22 97.1C22 97.597 21.5523 98 21 98C20.4477 98 20 97.597 20 97.1C20 96.603 20.3333 95.9 21 95C21.6667 95.9 22 96.603 22 97.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M11 99.1C11 99.597 10.5523 100 10 100C9.4477 100 9 99.597 9 99.1C9 98.603 9.3333 97.9 10 97C10.6667 97.9 11 98.603 11 99.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M30 88.1C30 88.5971 29.5523 89 29 89C28.4477 89 28 88.5971 28 88.1C28 87.6029 28.3333 86.9 29 86C29.6667 86.9 30 87.6029 30 88.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M33 97.1C33 97.597 32.5523 98 32 98C31.4477 98 31 97.597 31 97.1C31 96.603 31.3333 95.9 32 95C32.6667 95.9 33 96.603 33 97.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M38 92.1C38 92.5971 37.5523 93 37 93C36.4477 93 36 92.5971 36 92.1C36 91.6029 36.3333 90.9 37 90C37.6667 90.9 38 91.6029 38 92.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M17 92.1C17 92.5971 16.5523 93 16 93C15.4477 93 15 92.5971 15 92.1C15 91.6029 15.3333 90.9 16 90C16.6667 90.9 17 91.6029 17 92.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M39 84.1C39 84.5971 38.5523 85 38 85C37.4477 85 37 84.5971 37 84.1C37 83.6029 37.3333 82.9 38 82C38.6667 82.9 39 83.6029 39 84.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M24 85.1C24 85.5971 23.5523 86 23 86C22.4477 86 22 85.5971 22 85.1C22 84.6029 22.3333 83.9 23 83C23.6667 83.9 24 84.6029 24 85.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M14 82.1C14 82.5971 13.5523 83 13 83C12.4477 83 12 82.5971 12 82.1C12 81.6029 12.3333 80.9 13 80C13.6667 80.9 14 81.6029 14 82.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M22 76.1C22 76.5971 21.5523 77 21 77C20.4477 77 20 76.5971 20 76.1C20 75.6029 20.3333 74.9 21 74C21.6667 74.9 22 75.6029 22 76.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M9 78.1C9 78.5971 8.5523 79 8 79C7.4477 79 7 78.5971 7 78.1C7 77.6029 7.3333 76.9 8 76C8.6667 76.9 9 77.6029 9 78.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M33 80.1C33 80.5971 32.5523 81 32 81C31.4477 81 31 80.5971 31 80.1C31 79.6029 31.3333 78.9 32 78C32.6667 78.9 33 79.6029 33 80.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M17 70.1C17 70.5971 16.5523 71 16 71C15.4477 71 15 70.5971 15 70.1C15 69.6029 15.3333 68.9 16 68C16.6667 68.9 17 69.6029 17 70.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M28 69.1C28 69.5971 27.5523 70 27 70C26.4477 70 26 69.5971 26 69.1C26 68.6029 26.3333 67.9 27 67C27.6667 67.9 28 68.6029 28 69.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M34 63.1C34 63.5971 33.5523 64 33 64C32.4477 64 32 63.5971 32 63.1C32 62.6029 32.3333 61.9 33 61C33.6667 61.9 34 62.6029 34 63.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M24 60.1C24 60.5971 23.5523 61 23 61C22.4477 61 22 60.5971 22 60.1C22 59.6029 22.3333 58.9 23 58C23.6667 58.9 24 59.6029 24 60.1Z"
        fill="#C4C4C4"
      />
      <path
        d="M13 64.1C13 64.5971 12.5523 65 12 65C11.4477 65 11 64.5971 11 64.1C11 63.6029 11.3333 62.9 12 62C12.6667 62.9 13 63.6029 13 64.1Z"
        fill="#C4C4C4"
      />
      {children}
    </svg>
  );
};

NoCorrectAnswersGraphic.propTypes = propTypes;
